<div class="card card-body shadow bg-warning p-2 m-0">
	<h2>Report Generation</h2>
	<h5>Kindly select your report criteria and click go to generate report.</h5>
	<hr />
	<div class="row mb-3">
		<div class="col-12 col-md-2">
			<div>Report</div>
			<select class="browser-default form-select" [(ngModel)]="selectedReport" (change)="resetReady()">
				@for (item of reports; track item.key) {
					<optgroup [label]="item.key">
						@for (v of item.value; track v.index) {
							<option [value]="v.index">{{ v.name }}</option>
						}
					</optgroup>
				}
			</select>
		</div>

		@if (isDownloadTypeReport() == false) {
			@if (!sharedService.isBranchAccountHandler()) {
				<div class="col-12 col-md-2">
					<div class="row p-0 d-flex justify-content-start align-items-left">
						<div class="col-12">Group</div>
						<div class="col-12">
							<select class="browser-default form-select" [(ngModel)]="selectedCompanyGroup" (change)="getAllCompanies(selectedCompanyGroup)">
								<option [ngValue]="0">All</option>
								@for (group of companyGroupList; track group) {
									<option [ngValue]="group.id">{{ group.name }}</option>
								}
							</select>
						</div>
					</div>
				</div>
			}

			@if (sharedService.isRoles([enums.BOSS, enums.BRANCH_MANAGER_HEAD, enums.ADMIN, enums.AUDITOR, enums.FINANCE]) && !includesReport([enums.ASSET_SUMMARY_REPORT, enums.USAGE_REPORT, enums.COMPANY_SUMMARY_REPORT, enums.OFFICE_CASH_REPORT, enums.STAMP_HQ_SUMMARY])) {
				@if (companyList.length > 0) {
					<mat-form-field class="col-12 col-md-3" subscriptSizing="dynamic">
						<mat-label>Company</mat-label>
						<input class="companyInput" type="text" placeholder="Pick one" aria-label="Company" matInput [matAutocomplete]="auto" [(ngModel)]="selectedCompany" (input)="filterOptions($event.target.value)" />
						<mat-autocomplete autoActiveFirstOption #auto="matAutocomplete" [displayWith]="displayCompanyCode" [requireSelection]="true">
							@for (company of filteredCompany; track company.ID) {
								<mat-option [value]="company.ID">{{ company.CompanyCode }}</mat-option>
							}
						</mat-autocomplete>
					</mat-form-field>
				}
			}

			@if (!includesReport([enums.LIST_HUTANG, enums.STOCK, enums.MIDMONTH_REPORT, enums.USAGE_REPORT, enums.FORMJ_REPORT, enums.CUSTOMER_RECORD_REPORT, enums.CHARGES_BALANCE_SUMMARY])) {
				<mat-form-field class="col-12 col-md-2" subscriptSizing="dynamic">
					<mat-label>Start Date</mat-label>
					<input matInput readonly [matDatepicker]="startDatePicker" name="startDate" [(ngModel)]="startDate" required (change)="resetReady()" [disabled]="isAll" [max]="sharedService.getTodayDate()" />
					<mat-datepicker-toggle matSuffix [for]="startDatePicker"></mat-datepicker-toggle>
					<mat-datepicker #startDatePicker name="startDate"></mat-datepicker>
				</mat-form-field>
			}

			@if (!includesReport([enums.DAILY_REPORT, enums.MIDMONTH_REPORT, enums.USAGE_REPORT, enums.FORMJ_REPORT, enums.COMPANY_SUMMARY_REPORT, enums.CUSTOMER_RECORD_REPORT, enums.OFFICE_CASH_REPORT])) {
				<div class="col-12 col-md-2 d-flex">
					<mat-form-field subscriptSizing="dynamic">
						<mat-label>End Date</mat-label>
						<input matInput readonly [matDatepicker]="endDatePicker" name="endDate" [(ngModel)]="endDate" [min]="getMinDateForEndDate()" [disabled]="isAll" required (change)="resetReady()" [max]="sharedService.getTodayDate()" />
						<!-- <mat-datepicker-toggle matSuffix [for]="endDatePicker"></mat-datepicker-toggle> -->
						<span matSuffix class="suffix-buttons d-flex align-itmes-center">
							<button mat-icon-button (click)="selectToday(endDatePicker)" type="button">
								<i class="fas fa-redo opacity-50 fs-5"></i>
							</button>
							<mat-datepicker-toggle [for]="endDatePicker"></mat-datepicker-toggle>
						</span>
						<mat-datepicker #endDatePicker name="endDate"></mat-datepicker>
					</mat-form-field>
				</div>
			}

			@if (allowViewAll()) {
				<div class="col-12 col-md-3">
					<div class="form-check" style="width: 100% !important">
						<input type="checkbox" class="form-check-input" id="checkboxSummary" [(ngModel)]="isAll" name="isAll" [value]="isAll" style="position: relative; cursor: pointer" />
						<label class="form-check-label" for="checkboxSummary" style="font-weight: bold; color: red; font-size: 1.2rem; top: -10px !important; cursor: pointer">All</label>
					</div>
				</div>
			}
		}
	</div>

	<div class="row">
		<div class="col d-flex justify-content-end align-items-end">
			@if (isDownloadTypeReport() == false) {
				<button class="btn btn-info" (click)="generateReport()">Go</button>
			} @else {
				<button class="btn btn-dark" (click)="downloadReport()" [disabled]="disabledSubmitDL">Download</button>
			}
		</div>
	</div>
</div>
